import React from 'react';

const Contact = () => {
  return (
    <div className='contact'>
      <i className="ui-phone-line">
        +46 766536673
      </i>
    </div>
  )
}

export default Contact;